const endpoint = property => `/api/${ property }/discount`;
const membershipEndpoint = property => `/api/${ property }/membership-discount`;
const periodsendpoint = (property, id) => `/api/${property}/discount/${id}/periods`;

export default ['api', '$rootScope', function(api, $rootScope) {
  return {
    save: discount => {
      let url = discount.id ? `${ endpoint(api.property()) }/${ discount.id }` : endpoint(api.property());

      return api.upload(url, discount).then(response => response.data);
    },
    savePeriods: (data, id) => {
      return api.post(periodsendpoint(api.property(), id), data).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint(api.property()) }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint(api.property())+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint(api.property()) }/${ id }`)
        .then(response => response.data);
    },
    findMembershipDiscount: () => {
      return api.get(`${ membershipEndpoint(api.property()) }`)
        .then(response => response.data);
    },
    saveMembershipDiscount: details => {
      return api.post(`${ membershipEndpoint(api.property()) }`, details)
        .then(response => response.data);
    },
    toggleActive: id => {
      return api.get(`${ endpoint(api.property()) }/status/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint(api.property()) }?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/services/discount.service.js